import React, { useCallback, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { ColorContextProvider } from '../../src/providers/ColorContext';
import { MainNavigation } from '../MainNavigation/components/MainNavigation';
import { media } from '../themes/theme';
const OverrideGlobalStyle = createGlobalStyle `
  body {
    background-color: #fff;
  }
`;
const position = '100%';
const Wrapper = styled.div `
  background-color: ${({ theme }) => theme.colors.lightgrey};
  background-image: url("data:image/svg+xml,%3Csvg width='100%25' height='100%25' viewBox='0 0 1920 150' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' xmlns:serif='http://www.serif.com/' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;'%3E%3Cpath d='M0,139.27L0.373,139.27L0.373,120.828L0,120.828L0,46.23C60.44,50.342 273.87,67.713 516.55,120.828C804,57.876 1049.15,45.08 1049.15,45.08L1920,0L1920,150L0,150L0,139.27Z' style='fill:white;fill-rule:nonzero;'%3E%3C/path%3E%3C/svg%3E");
  background-repeat: no-repeat, no-repeat;
  background-position: 0% ${position};
  display: flex;
  flex: 1;
  position: relative;
  top: ${props => `-${props.offsetTop}px`};
`;
const InnerWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: ${props => props.theme.application.maxContentWidth};
  padding: ${props => `${props.offsetTop / 16 + 1}rem 1rem 0 1rem`};

  ${media.tablet `
    flex-direction: row;
  `}
`;
const Content = styled.div `
  align-self: flex-start;
  margin-bottom: 2rem;
  max-width: 45rem;

  ${media.tablet `
    margin-bottom: 5rem;
  `}
`;
const Doodle = styled.div `
  width: 15rem;
  align-self: center;
  margin-bottom: -5rem;

  ${media.tablet `
    width: 20rem;
    margin-left: 2rem;
    align-self: flex-end;
    margin-bottom: 0;
  `}
`;
const StickyHeader = styled.header `
  z-index: 1000;

  @media (min-height: 35rem) {
    position: sticky;
  }
`;
export const DoodleLayout = ({ children, doodle, headerLogo = null, }) => {
    const [offsetTop, setOffsetTop] = useState(100);
    const measuredRef = useCallback(node => {
        if (node !== null) {
            setOffsetTop(node.getBoundingClientRect().height);
        }
    }, []);
    return (React.createElement(ColorContextProvider, { backgroundColor: "#fff" },
        React.createElement(OverrideGlobalStyle, null),
        headerLogo && (React.createElement(StickyHeader, { ref: measuredRef },
            React.createElement(MainNavigation, { hasHamburgerMenu: false, isLogoAnimated: false, logo: headerLogo }))),
        React.createElement(Wrapper, { offsetTop: offsetTop },
            React.createElement(InnerWrapper, { offsetTop: offsetTop },
                React.createElement(Content, null, children),
                React.createElement(Doodle, null, doodle)))));
};
